import React from 'react';
import { AlertIcon, AlertIconProps } from '../Icon';
import Stack from '../Stack';
import Text from '../Text';

export type InfoIconOwnProps = {
    alertIconProps: AlertIconProps;
    title: string;
    subText?: string;
};

export type InfoIconProps = InfoIconOwnProps;

const InfoIcon: React.FC<InfoIconProps> = (props) => {
    return (
        <Stack
            fullWidth
            vertical
            justify="center"
            align="center"
            space={8}
            style={{
                paddingTop: 16,
                paddingBottom: 16,
            }}
        >
            <AlertIcon {...props.alertIconProps} />
            <Stack vertical space={4} align="center">
                <Text variant="h4" alignText="center">
                    {props.title}
                </Text>
                {props.subText && (
                    <Text variant="body-1" alignText="center">
                        {props.subText}
                    </Text>
                )}
            </Stack>
        </Stack>
    );
};

export default React.memo(InfoIcon);
